export function resolveCssVar(varName: string, fallback: string): string {
    const resolved = getComputedStyle(document.documentElement).getPropertyValue(varName).trim();
    return resolved || fallback;
}
